import { Paralax2 as c } from "../EditPanel/Paralax2";
import { conLanding } from "../Models/Landing";

export default class Paralax2 extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}